export default {
  mutation: {
    overview: 'Details of the mutation',
    name: 'Mutation',
    search: {},
    list: {
      title: 'List of mutations',
      headers: {
        allowedToAccept: 'Authorized to accept',
        allowedToCancel: 'Outgoing',
        auteurMouvement: 'Author of the movement',
        demandePriseEnChargeBilan: 'Check-up support request',
        encours: 'Ongoing',
        etablissementDestination: 'Destination company',
        etablissementSource: 'Source company',
        motifMouvement: 'Reason for movement',
        participant: 'Participant',
        typeMouvement: 'Type of movement',
        date: 'Date',
      },
      search: {
        encours: 'Ongoing mutations',
        entrantes: 'Incoming mutations',
        sortantes: 'Outgoing mutations',
      },
    },
    participant: 'Participant',
    auteurMouvement: 'Author of the movement',
    date: 'Date',
    typeMouvement: 'Type of movement',
    motifMouvement: 'Reason for movement',
    etablissementSource: 'Source company',
    etablissementDestination: 'Destination company',
    accepter: {
      action: 'Accept the mutation',
      title: 'Acceptance of the transfer',
      message: 'Do you confirm that you wish to accept the transfer?',
      priseEnChargeBilanEnCours:
        'By accepting the transfer, Your company will take care of the ongoing health check-up of the participant',
    },
    annuler: {
      action: 'Cancel the transfer',
      title: 'Cancellation of the transfer',
      message: 'Do you confirm that you want to cancel the transfer?',
    },
    encours: 'Mutation',
    demande: {
      envoyee: 'The transfer request has been sent',
      annullee: 'The transfer was successfully canceled',
      acceptee: 'The mutation has been accepted successfully',
    },
    nonTrouve: 'The mutation does not exist',
    correspondantNonTrouve: 'The requesting correspondent was not found',
  },
}
